
import { Card, CardBody, CardHeader, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2'
import Moment from 'moment'
import "react-datepicker/dist/react-datepicker.css";
import { useState, useContext, useEffect } from "react";
import { Api } from "../../../componentes/Api"

import * as moment from "moment";


    var Efectivo=0;
    var Credito=0;
    var Tarjeta=0;
    var Transferencia=0;
    var Cheque=0;
    var Total=0;
const Reportec = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [buscarPor, setBuscarPor] = useState("fecha")
    const [ventas, setVentas] = useState([])
    const [EmpresaD, setEmpresaD] = useState([]);
    const [imageSrc, setImageSrc] = useState("");
    const [Impresion, setImpresion] = useState(false);
    const [TransacionesDiarias, setTransacionesDiarias] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    let correo = JSON.parse(user);

    const Empresa = async () => {
        let response = await fetch(Api + "Pacientes/Empresa/" + correo.empresaID);
        if (response.ok) {
            let data = await response.json()
            setEmpresaD(data)
        }

    }
    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + correo.empresaID);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

    const [cssContent, setCssContent] = useState('');
    useEffect(() => {
        fetch('/css/ReportesFacturaSeguro.css')
            .then(response => response.text())
            .then(text => setCssContent(text))
            .catch(error => console.error('Error al cargar el CSS:', error));
        fetchImage();
    }, []);


    useEffect(() => {
        Empresa()
    },[])

    const buscarVenta = async () => {
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
       
        let _fechaInicio = fechaInicio.toLocaleDateString('es-PE', options)
        let _fechaFin = fechaFin.toLocaleDateString('es-PE', options)

        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");


      //  let response = await fetch(Api + `VentasTrans/HistorialFactura?buscarPor=${buscarPor}&fechaInicio=${_fechaInicio}&fechaFin=${_fechaFin}`)
        let response = await fetch(Api + "ReportesMedical/ReporteTransaccionesDiaria/"  + fi + "/" + ff)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                if (data.length >= 1) {
                    setVentas(data);
                    Credito = data.reduce((x, y) => {
                        return x + y.credito;
                    }, 0)
                    Efectivo = data.reduce((x, y) => {
                        return x + y.efectivo;
                    }, 0)
                    Tarjeta = data.reduce((x, y) => {
                        return x + y.tarjeta;
                    }, 0)
                    Transferencia = data.reduce((x, y) => {
                        return x + y.transferencia;
                    }, 0)
                    Cheque = data.reduce((x, y) => {
                        return x + y.cheque;
                    }, 0)
                    Total = data.reduce((x, y) => {
                        return x + y.totalPago;
                    }, 0)
                    setTransacionesDiarias(true)
                } else { setVentas([]); }
            })}

    const estilos = `<style> @media print {
  @page {
    size: A4 landscape;
  }</style>
`;
    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Recibo de Pago</title><style>");
        ventana.document.write(cssContent);
        ventana.document.write("</style></head><body>");

        ventana.document.write(recibo);
        ventana.document.write("</body></html>");
        ventana.document.close();
        // Esperar a que la imagen cargue antes de imprimir
        // Esperar a que la imagen cargue antes de imprimir
        const logoImg = ventana.document.getElementById("logoImg");
        logoImg.onload = function () {

        };
        setTimeout(() => {
            ventana.print();
        }, 2000);
    };


    return (
        <>
            <Row>
                <Col sm={12}>
                    <Card>
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            Historial de ventas
                        </CardHeader>
                        <CardBody>
                            <Row className="align-items-end">
            <Col sm={3}>
                <FormGroup>
                    <Label>Fecha Inicio:</Label>
                    <DatePicker
                        className="form-control form-control-sm"
                        selected={fechaInicio}
                        onChange={(date) => setFechaInicio(date)}
                        dateFormat='dd/MM/yyyy'
                    />
                </FormGroup>
            </Col>

            <Col sm={3}>
                <FormGroup>
                    <Label>Fecha Fin:</Label>
                    <DatePicker
                        className="form-control form-control-sm"
                        selected={fechaFin}
                        onChange={(date) => setFechaFin(date)}
                        dateFormat='dd/MM/yyyy'
                    />
                </FormGroup>
            </Col>
            <Col sm={3}>
                <FormGroup>
                    <Button color="success" size="sm" block onClick={buscarVenta}>
                        <i className="fa fa-search" aria-hidden="true"></i> Transferencia Diaria
                    </Button>
                </FormGroup>
            </Col>
           
                            </Row>
                            <hr></hr>
                    
                        <div class="summary">
                            <div class="summary-item">  Efectivo:<b>{Efectivo.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                            <div class="summary-item"> Credito:<b>{Credito.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                            <div class="summary-item">Tarjeta:<b> {Tarjeta.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">Transfe:<b>{Transferencia.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">  Cheque:<b>{Cheque.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                            <div class="summary-item">Total:<b>{Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                        </div>
                      <Row>
                                <Col sm="12">
                

                                </Col>

                            </Row>

                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal className="modal-preguntas" isOpen={TransacionesDiarias}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Transaciones Diarias  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setTransacionesDiarias(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div id="reciboPago" className="mt-4 p-3">
                        <div class="rotar-90">
                        <div>

                                <div className="content" style={{ display: "flex", alignItems: "center", gap: "20px" }}>

                                    <img src={imageSrc} alt="Logo Apatech" id="logoImg" class="logoImg" style={{ width: "100px" }} />
                            <div class="company-info">
                                <h1>{EmpresaD.descripcion}</h1>
                               {EmpresaD.direccion}<br></br>
                                        RNC: {EmpresaD.rnc}< br ></br>
                               TEL: {EmpresaD.telefono} CORREO: {EmpresaD.email}
                            </div>
                         
                            </div>
                            <br></br>
                            <div class="content">
                                <div class="header">
                                    <div>
                                       
                                    </div>
                                    <br></br>
                                    <div class="fecha">
                                        <h4 class="subtitle">Reporte de Transacciones Diarias</h4>

                                        Fecha/Hora: {moment(new Date()).format("DD/MM/YYYY  /  HH:mm:ss ") }<br/>
                                        Usuario: { correo.nombre}<br/>
                                                Página: 
                                        Fecha Proceso: {moment(new Date()).format("DD/MM/YYYY")}
                                                </div>
                                            </div>

                                            <div class="info">
                                                <div></div>
                                                <div class="right-align">***COMISIONES***</div>
                                            </div>

                                            <table class="tabla">
                                                <tr>
                                                    <th class="numero">No Paciente</th>
                                                    <th class="paciente">Paciente</th>
                                                    <th class="examen">Examen</th>
                                                    <th class="costo">Costo</th>
                                                    <th class="seguro">Tipo Seguro</th>
                                                    <th class="costo">Cob. Seg.</th>
                                                    <th class="efectivo">Efectivo</th>
                                                    <th>Cheques</th>
                                                    <th>Tarjeta</th>
                                                    <th>C & E</th>
                                                    <th>Pagado</th>
                                                    <th>Centro</th>
                                                    <th>Técnico</th>
                                                    <th>Referido</th>
                                                </tr>
                                             
                                    {ventas.map( x =>(<tr>
                                        <td>{x.facturaLineaID }</td>
                                        <td>{ x.nombreCliente}</td>
                                        <td>{x.descripcionArticulo}<br />{x.porcientoAcc}% {x.porcientoRef}% 0%</td>
                                        <td class="right-align">{ x.monto}</td>
                                        <td>{x.NombreSeguro }<br />{x.cobertura } %</td>
                                        <td class="right-align">{x.montoTotalCobertura.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") }</td>
                                        <td class="right-align">{x.efectivo.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                        <td class="right-align">{x.cheque }</td>
                                        <td class="right-align">{x.tarjeta.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") }</td>
                                        <td class="right-align">{x.cxc.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") }</td>
                                        <td class="right-align">{x.totalLinea.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                        <td class="right-align">0.00</td>
                                        <td class="right-align">0.00</td>
                                        <td class="right-align">{x.montoRef.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    </tr>))}
                                               
                                          
                                            </table>

                           
                                </div>
                                <div class="" style={{ width: "20%" }} hidden={Empresa.itbisIncluido} >

                                    <div class="summary">
                                        <div class="summary-item">  Efectivo:<b>{Efectivo.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                                        <div class="summary-item"> Credito:<b>{Credito.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                                        <div class="summary-item">Tarjeta:<b> {Tarjeta.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                                        <div class="summary-item">Transfe:<b>{Transferencia.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                                        <div class="summary-item">  Cheque:<b>{Cheque.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                                        <div class="summary-item">Total:<b>{Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                                    </div>
                                  

                                </div>
                    </div>
                    </div>
                    </div>
                 
                    <Button color="secondary" onClick={() => imprimirRecibo()}>Imprimir Recibo</Button>
                </ModalBody>

            </Modal>



        </>
        )

}
export default Reportec;